import { AlmeMessageEventData } from "@alme/post-message-api/AlmeMessageEventData";
import { useEffect } from "react";
import defaultLogger from "../Logger";
import { ClientCommunicator } from '@alme/post-message-api/ClientCommunicator';

export function useAlmeMessageListener(clientCommunicator: ClientCommunicator, onAlmeMessage: (payload: AlmeMessageEventData) => void): void {
    useEffect(() => {
        try {
            const almeMessageCallback = clientCommunicator.addAlmeMessageListener(onAlmeMessage);

            return () => {
                clientCommunicator.removeAlmeMessageListener(almeMessageCallback);
            };
        } catch (error) {
            defaultLogger.error("Error using callback", error);
        }
    }, [clientCommunicator, onAlmeMessage]);
}
